import React, { useState, useEffect } from "react";
import demoWorkers from "./WorkerData";

// States and districts for cascading dropdowns
const states = {
  Maharashtra: ["Mumbai", "Pune"],
  Karnataka: ["Bangalore Urban"],
};

const districts = {
  Mumbai: ["Mumbai"],
  Pune: ["Pune"],
  "Bangalore Urban": ["Bangalore"],
};

const WorkerFinder = () => {
  const [workerType, setWorkerType] = useState("");
  const [state, setState] = useState("");
  const [district, setDistrict] = useState("");
  const [city, setCity] = useState("");
  const [filteredWorkers, setFilteredWorkers] = useState([]);

  const handleSearch = () => {
    const results = demoWorkers.filter(
      (w) =>
        (workerType ? w.type === workerType : true) &&
        (state ? w.state === state : true) &&
        (district ? w.district === district : true) &&
        (city ? w.city === city : true)
    );
    setFilteredWorkers(results);
  };

  useEffect(() => {
    setDistrict("");
    setCity("");
  }, [state]);

  useEffect(() => {
    setCity("");
  }, [district]);

  return (
    <div className="p-6 max-w-5xl mx-auto">
      <h1 className="text-2xl font-bold mb-4">Find a Worker</h1>

      <div className="grid grid-cols-1 md:grid-cols-5 gap-4 mb-6">
        <select
          className="border p-2 rounded"
          value={workerType}
          onChange={(e) => setWorkerType(e.target.value)}
        >
          <option value="">Select Worker Type</option>
          <option value="Labour">Labour</option>
          <option value="Mason">Mason</option>
          <option value="Plumber">Plumber</option>
          <option value="Carpenter">Carpenter</option>
          <option value="Contractor">Contractor</option>
        </select>

        <select
          className="border p-2 rounded"
          value={state}
          onChange={(e) => setState(e.target.value)}
        >
          <option value="">Select State</option>
          {Object.keys(states).map((s) => (
            <option key={s} value={s}>
              {s}
            </option>
          ))}
        </select>

        <select
          className="border p-2 rounded"
          value={district}
          onChange={(e) => setDistrict(e.target.value)}
          disabled={!state}
        >
          <option value="">Select District</option>
          {state &&
            states[state].map((d) => (
              <option key={d} value={d}>
                {d}
              </option>
            ))}
        </select>

        <select
          className="border p-2 rounded"
          value={city}
          onChange={(e) => setCity(e.target.value)}
          disabled={!district}
        >
          <option value="">Select City</option>
          {district &&
            districts[district].map((c) => (
              <option key={c} value={c}>
                {c}
              </option>
            ))}
        </select>

        <button
          className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
          onClick={handleSearch}
        >
          Search
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {filteredWorkers.length > 0 ? (
          filteredWorkers.map((worker, idx) => (
            <div
              key={idx}
              className="border p-4 rounded shadow hover:shadow-lg transition"
            >
              <img
                src={
                  worker.photo
                    ? worker.photo
                    : "https://via.placeholder.com/150?text=No+Photo"
                }
                alt={worker.name}
                className="w-full h-40 object-cover rounded mb-2"
              />
              <h2 className="font-bold text-lg">{worker.name}</h2>
              <p>Mobile: {worker.mobile}</p>
              <p>Type: {worker.type}</p>
              <p>Experience: {worker.experience} years</p>
              <p>Rating: {worker.rating} ⭐</p>
              <p>Specialization: {worker.specialization}</p>
            </div>
          ))
        ) : (
          <p>No workers found. Adjust your filters.</p>
        )}
      </div>
    </div>
  );
};

export default WorkerFinder;
